var _style, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 300",
    style: {
      enableBackground: "new 0 0 1200 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:url(#XMLID_2_);}\r\n\t.st2{fill:url(#XMLID_3_);}\r\n\t.st3{fill:url(#XMLID_4_);}\r\n\t.st4{fill:url(#XMLID_5_);}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2129_",
    className: "st0",
    d: "M406.9,159.8v-6.9c0-19.9,6.7-32.2,23.1-32.2c13.8,0,20.3,8.6,20.3,22h26.5V138 c0-23.1-15.1-41.7-47.5-41.7c-35.2,0-50.5,23.7-50.5,56.5v6.9c0,32.6,15.3,56.5,50.5,56.5c32.4,0,47.5-18.1,47.5-39.9v-4.5h-26.5 c0,11.2-6,19.9-20.3,19.9C413.5,191.8,406.9,179.5,406.9,159.8z M544,216.4c35.8,0,51.8-24,51.8-56.5v-6.9c0-32.8-16-56.5-51.8-56.5 c-35.8,0-51.8,23.7-51.8,56.5v6.9C492.2,192.4,508.2,216.4,544,216.4z M544,191.8c-16.4,0-23.7-12.3-23.7-31.9v-6.9 c0-19.9,7.3-32.2,23.7-32.2s23.7,12.3,23.7,32.2v6.9C567.7,179.5,560.4,191.8,544,191.8z M714,213.6v-78.3 c0-20.7-10.1-38.9-35.2-38.9c-18.1,0-30,7.6-37.1,17.9l-2.6-15.1h-24.8l1.9,32.4v82h28.1v-79.6c3.2-5.4,10.6-13.2,23.7-13.2 c12.7,0,18.1,8,18.1,19v73.8H714z M835.6,213.6v-78.3c0-20.7-10.1-38.9-35.2-38.9c-18.1,0-30,7.6-37.1,17.9l-2.6-15.1h-24.8 l1.9,32.4v82h28.1v-79.6c3.2-5.4,10.6-13.2,23.7-13.2c12.7,0,18.1,8,18.1,19v73.8H835.6z M958.3,166.7v-13.2 c0-32.6-16-57.2-51.2-57.2c-35.4,0-52.4,24.6-52.4,57.2v5.6c0,32.6,16.6,57.2,53.5,57.2c32.8,0,50.1-18.1,50.1-38.6v-0.9h-26.5 c0,8.6-8,17.7-23.3,17.7c-16,0-24.6-9.1-25.7-27.8H958.3z M906.5,118.2c15.3,0,22.7,9.7,23.5,27.8h-47.3 C883.9,127.9,891.4,118.2,906.5,118.2z M970.4,99.2l31.1,55.9l-31.1,58.5h31.9l21.6-44l21.8,44h31.9l-31.1-58.5l31.1-55.9H1045 l-20.9,41.2L1003,99.2H970.4z M1132.3,99.2V66.8h-28.1v32.4l-47.5,0v24.6l47.5,0v52.4c0,29.6,16.4,40.1,39.9,40.1 c10.1,0,16-1.9,17.7-2.8v-23.3c-1.3,0.6-6.9,1.5-11,1.5c-11.7,0-18.6-3.2-18.6-18.6v-49.4h31.7V99.2H1132.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2126_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.5399,
    y1: 100.0395,
    x2: 279.5708,
    y2: 243.9304
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29C1FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5022,
    style: {
      stopColor: "#AB00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5082,
    style: {
      stopColor: "#AC03FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6406,
    style: {
      stopColor: "#C840B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7601,
    style: {
      stopColor: "#DE7082"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8629,
    style: {
      stopColor: "#EE935B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9448,
    style: {
      stopColor: "#F7A844"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9956,
    style: {
      stopColor: "#FBB03B"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2128_",
    className: "st1",
    d: "M129.2,52.8c0,0-10.4,10.4-22.7,22.7l-49.3,48.9c-20.1,20.5-12.2,41.4,1.8,55.4L99.4,220 c3.6,3.6,17.6,18.3,28.8,6.8c6.5-6.5,5-16.5,1.4-20.5l-46.4-46c-8.3-8.3-4.3-15.8,4-23.7L126.7,97l24.8,24.8 c8.6,8.6,19.4,11.9,28.4,2.9s3.6-17.6-5-26.3l-27.3-27.3L129.2,52.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 90.583,
    y1: 47.2727,
    x2: 313.6139,
    y2: 191.1636
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29C1FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5022,
    style: {
      stopColor: "#AB00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5082,
    style: {
      stopColor: "#AC03FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6406,
    style: {
      stopColor: "#C840B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7601,
    style: {
      stopColor: "#DE7082"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8629,
    style: {
      stopColor: "#EE935B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9448,
    style: {
      stopColor: "#F7A844"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9956,
    style: {
      stopColor: "#FBB03B"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2127_",
    className: "st2",
    d: "M131.4,54.6c-6.5-6.5-15.8-10.1-24.8-1.1s-4.3,19.1,1.4,24.8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2123_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.9401,
    y1: 65.3193,
    x2: 301.971,
    y2: 209.2101
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29C1FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5022,
    style: {
      stopColor: "#AB00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5082,
    style: {
      stopColor: "#AC03FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6406,
    style: {
      stopColor: "#C840B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7601,
    style: {
      stopColor: "#DE7082"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8629,
    style: {
      stopColor: "#EE935B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9448,
    style: {
      stopColor: "#F7A844"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9956,
    style: {
      stopColor: "#FBB03B"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2125_",
    className: "st3",
    d: "M211.2,244.8c0,0,10.4-10.4,22.7-22.7l49.3-49.3c20.5-20.5,12.6-41.4-1.8-55.4l-40.3-39.9 c-3.6-3.6-17.6-18.3-28.8-6.8c-6.5,6.5-5,16.5-1.4,20.5l46.4,46c8.3,8.3,4.3,15.8-4,23.7l-39.6,39.6l-24.8-24.8 c-8.6-8.6-19.4-11.9-28.4-2.9s-3.6,17.6,5,26.3l27.3,27.3L211.2,244.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.8044,
    y1: 118.2295,
    x2: 267.8353,
    y2: 262.1204
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29C1FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5022,
    style: {
      stopColor: "#AB00FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5082,
    style: {
      stopColor: "#AC03FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6406,
    style: {
      stopColor: "#C840B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7601,
    style: {
      stopColor: "#DE7082"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8629,
    style: {
      stopColor: "#EE935B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9448,
    style: {
      stopColor: "#F7A844"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9956,
    style: {
      stopColor: "#FBB03B"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2124_",
    className: "st4",
    d: "M209.1,243c6.5,6.5,15.8,10.4,24.8,1.4s4.3-19.1-1.4-24.8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnext);
export default __webpack_public_path__ + "static/media/connext.dbd6024a84568f45b4b90f2ddde98a51.svg";
export { ForwardRef as ReactComponent };